import React from "react";
import { Grid, Paper, Typography, Box, Button, Chip, CircularProgress } from "@material-ui/core";
import emma_w from "../../../global/imagenes/emma_w.png";                 // ajusta ruta real
import useStyles from "./styles";
import useEncuestaGenero from "./hooks/useEncuestaGenero";
import PreguntasList from "./components/PreguntasList";
import DetallePregunta from "./components/DetallePregunta";
import EditorPregunta from "./components/EditorPregunta";
import TareasTerminadas from "../TareasTerminadas";
import ConfirmarAccion from "../ConfirmarAccion";
import { PowerSettingsNew } from "@material-ui/icons";
import { consulta, obtenerValoresFiltros } from "../../../global/js/funciones";
import { useDispatch } from "react-redux";
import { actualizarMensaje } from "../../../redux/actions/actGlobal";

export default function AdminEncuestaGenero() {
  const classes = useStyles();

  const {
    loading, preguntas, respuestas,
    isEditing, setIsEditing,
    selectedId, setSelectedId,
    selected,
    preguntaEditando,
    addQuestion,
    handleEditarPregunta,
    onChangeCampoPregunta,
    updateOption, deleteOption, addOption,
    guardarPregunta,
    eliminarPregunta,
    hasCambios,
    limpiarEdicion
  } = useEncuestaGenero();

  const dispatch = useDispatch();
  const [showUnsaved, setShowUnsaved] = React.useState(false);
  const pendingActionRef = React.useRef(null);
  const [encuestaActiva, setEncuestaActiva] = React.useState(null);

  const encuestaId = React.useMemo(
    () => (selected?.encuesta_id || preguntaEditando?.encuesta_id || null),
    [selected, preguntaEditando]
  );

  React.useEffect(() => {
    const cargarEstadoEncuesta = async () => {
      try {

        const periodo = await obtenerValoresFiltros([
          { llave: "codigo", valor: "per_enc_gen" },
        ]);

        const v = periodo?.[0]?.valorb;
        const activa = String(v).toLowerCase() === "activo";
        setEncuestaActiva(!!activa);
      } catch (e) {
        console.error("Error al obtener el estado de la encuesta:", e);
      } finally {
      }
    };

    cargarEstadoEncuesta();
  }, []);

  const doOrConfirm = React.useCallback((fn) => {
    if (hasCambios) {
      pendingActionRef.current = fn;
      setShowUnsaved(true);
    } else {
      fn();
    }
  }, [hasCambios]);

  // Confirmar desde el modal
  const confirmarDescartar = React.useCallback(() => {
    const fn = pendingActionRef.current;
    setShowUnsaved(false);
    pendingActionRef.current = null;
    limpiarEdicion();
    if (typeof fn === 'function') fn();
  }, [limpiarEdicion]);

  const cancelarDescartar = React.useCallback(() => {
    setShowUnsaved(false);
    pendingActionRef.current = null;
  }, []);

  const onToggleEncuesta = (activo) => {
    consulta(
      `api/v1.0/personas/encuesta-genero/periodo/actualizar-estado`,
      { activo },
      'post',
      (error, estado, resp) => {
        if (estado === 200 && resp) {
          dispatch(
            actualizarMensaje({
              titulo: resp.titulo || "Estado de encuesta actualizado.",
              tipo: "success",
              mostrar: true,
              tiempo: 4000,
            })
          );
          setEncuestaActiva(resp.estado === "activo");
        } else {
          dispatch(
            actualizarMensaje({
              titulo: resp?.titulo || "No se pudo actualizar el estado de la encuesta.",
              tipo: "warning",
              mostrar: true,
              tiempo: 4000,
            })
          );
        }
      }
    );
  };

  const handleSelectPregunta = (id) => {
    if (id === selectedId) {
      return;
    }
    doOrConfirm(() => {
      limpiarEdicion();
      setSelectedId(id);
    });
  };

  if (loading) {
    return (
      <TareasTerminadas
        imagen={emma_w}
        mensaje="Cargando..."
        widthImg="7%"
        marginTop="7%"
      />
    );
  }

  return (
    <div className="">
      <div className={classes.moduloReset}>
        <div className={classes.wrap}>
          <Grid container spacing={3}>
            {/* Izquierda */}
            <Grid item xs={12} md={5} lg={5}>
              <PreguntasList
                preguntas={preguntas}
                selectedId={selectedId}
                setSelectedId={handleSelectPregunta}
                handleEditarPregunta={(q) => doOrConfirm(() => handleEditarPregunta(q))}
                eliminarPregunta={(id) => doOrConfirm(() => eliminarPregunta(id))}
                addQuestion={() => doOrConfirm(() => addQuestion())}
                classes={classes}
              />
              <Box mt={3} p={1} border="1px solid #e0e0e0" borderRadius={8}>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                  <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                    Estado de la encuesta
                  </Typography>

                  <Chip
                    size="small"
                    label={encuestaActiva ? "Activa" : "Inactiva"}
                    style={{
                      backgroundColor: encuestaActiva ? "#4caf50" : "#9e9e9e",
                      color: "white",
                      fontWeight: 500,
                    }}
                  />
                </Box>

                <Typography
                  variant="body2"
                  color="textSecondary"
                  style={{ marginTop: 3, marginBottom: 12 }}
                >
                  {encuestaActiva
                    ? "La encuesta está actualmente activa para los usuarios."
                    : "La encuesta está desactivada y no es visible para los usuarios."}
                </Typography>
                <Box display="flex" justifyContent="center">
                  <Button
                    variant="contained"
                    color={encuestaActiva ? "secondary" : "primary"}
                    startIcon={<PowerSettingsNew />}
                    onClick={() => onToggleEncuesta(!encuestaActiva)}
                    style={{
                      fontWeight: 600,
                      borderRadius: 6,
                      minWidth: 130,
                      padding: "5px 12px",
                      textTransform: "none",
                    }}
                  >
                    {encuestaActiva
                      ? "Desactivar"
                      : "Activar"}
                  </Button>
                </Box>
              </Box>
            </Grid>

            {/* Centro */}
            <Grid item xs={12} md={7} lg={6}>
              {isEditing ? (
                <EditorPregunta
                  preguntaEditando={preguntaEditando}
                  onChangeCampoPregunta={onChangeCampoPregunta}
                  guardarPregunta={guardarPregunta}
                  updateOption={updateOption}
                  deleteOption={deleteOption}
                  addOption={addOption}
                  loading={loading}
                  classes={classes}
                />
              ) : (
                <Paper className={classes.editorPaper}>
                  <DetallePregunta q={selected} respuestas={respuestas} />
                </Paper>
              )}
            </Grid>
          </Grid>
          <ConfirmarAccion
            titulo="Cambios sin guardar"
            mensaje1="Tienes cambios sin guardar. Si continúas se perderán. ¿Deseas seguir?"
            dato={{}}
            modalConAccion={showUnsaved}
            ejecutarAccion={confirmarDescartar}
            mostrarModalConfAccion={(open) => open ? setShowUnsaved(true) : cancelarDescartar()}
          />
        </div>
      </div>
    </div>
  );
}
